import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';
import { NodeID } from '../../sections/types/Node';

export interface IRejectPoolNodeParams {
  nodeId: NodeID;
  clusterId: string;
  siteId: string;
}

export interface IRejectPoolNodeResult extends IResult {
  success?: {
    nodeId: NodeID;
    displayName?: string;
    status: string;
    clusterId: string;
  };
  siteId?: string;
  error?: BaasEdgePoolError;
}

export class RejectPoolNodeRequest extends Request<IRejectPoolNodeParams, IRejectPoolNodeResult> {
  constructor(params: IRejectPoolNodeParams) {
    super('rejectPoolNode', params);
  }
}
